import { Icon } from 'palette/Icon';
import '../styles/GenderFilterItem.scss';

export function GenderFilterItem({ label, icon, onClick }) {
    return (
        <button
            className="gender-filter-item"
            onClick={onClick}
        >
            {label}
            <Icon
                className="gender-filter-item__icon"
                name={icon}
                size="x-small"
            />
        </button>
    );
}
